import React from 'react';
import styled from "styled-components";
import Icon from "@atoms/icon";
import QuoteIcon from "@icons/quote.svg";

const HayaatQuoteSection = ({windowSize}) => {
    return (
        <Container className="container d-flex flex-column flex-lg-row mt-lg-40">
            <Icon width={(windowSize > 991) ? "100" : '50'} height={(windowSize > 991) ? "118" : '50'}><QuoteIcon/></Icon>

            <h2 className="mr-0 mr-lg-24 mt-8 mt-lg-0">برای سفر به مشهد و خرید واحدهای هتل حیات، اقامت در بارگاه امام رئوف را مهمان ما هستید!</h2>

            {
                (windowSize > 991) ?
                    <Icon className="ml-8 quote-icon" width={(windowSize > 991) ? "100" : '50'} height={(windowSize > 991) ? "118" : '50'}><QuoteIcon/></Icon> : ''
            }
        </Container>
    );
};

export default React.memo(HayaatQuoteSection);

// styles

const Container = styled.div`
    position: relative;

    h2 {
        font-size: 50px;
        font-weight: 500;
        line-height: 1.8;
        position: relative;
    }
    
    .quote-icon {
        position: absolute;
        left: 0;
        bottom: -32px;
        opacity: .1;
        transform: rotate(180deg);
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        h2 {
            font-size: 40px;
            line-height: 1.5;
        }
    }
    
    .icons {
        svg {
            path {
                stroke: ${props => props.theme.black};
                fill: ${props => props.theme.black};
            }
        }
    }
`;